export default __webpack_public_path__ + "static/media/NotificacaoIconGrey.bbc11026.svg";